import { Controller } from "@hotwired/stimulus";

// Superhuman-style j/k navigation between task review pages: j opens the next
// card in the current column, k the previous one. The URLs are computed
// server-side (same ordering and filters as the board) and passed in as
// values; either may be absent at the column edges.
//
// e skips the open card (nothing is sent) by clicking its skip button, the
// same as a mouse click; the skip action then lands on the next card. Cards
// that can't be skipped (already resolved) have no skip target, so e is a
// no-op there.
//
//   <div data-controller="task-review"
//        data-action="keydown@window->task-review#key"
//        data-task-review-next-url-value="..."
//        data-task-review-prev-url-value="...">
export default class extends Controller {
  static targets = ["skip"];

  static values = {
    nextUrl: { type: String, default: "" },
    prevUrl: { type: String, default: "" },
  };

  key(event) {
    if (event.defaultPrevented) return;
    if (event.metaKey || event.ctrlKey || event.altKey) return;
    // The page has edit-draft and rewrite-guidance textareas; never steal
    // keystrokes from a typing context.
    if (event.target instanceof Element && event.target.closest("input, textarea, select, [contenteditable]")) return;

    const key = event.key.toLowerCase();
    if (key === "j" && this.nextUrlValue) {
      event.preventDefault();
      window.Turbo.visit(this.nextUrlValue);
    } else if (key === "k" && this.prevUrlValue) {
      event.preventDefault();
      window.Turbo.visit(this.prevUrlValue);
    } else if (key === "e" && this.hasSkipTarget && !this.skipping) {
      event.preventDefault();
      // One skip per page load: a held-down key must not fire twice.
      this.skipping = true;
      this.skipTarget.click();
    }
  }
}
